// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./project/css/images/favicon.png", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("./project/css/images/logo_tecnalia_white.svg", import.meta.url);
// Module
var code = `<!DOCTYPE html>
<html>

<head>
    <title>LCOE</title>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link href="${___HTML_LOADER_IMPORT_0___}" rel="shortcut icon" type="image/x-icon" />
</head>

<body class="header-tablet-and-mobile-fixed aside-enabled">
    <div id="splash" data-visible="true">
        <div class="lds-grid">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div class="d-flex flex-column flex-root">
        <div class="page d-flex flex-row flex-column-fluid">
            <div class="aside py-9">
                <div class="aside-menu flex-column-fluid ps-5 pe-3 mb-7">
                    <div class="w-100 hover-scroll-overlay-y d-flex pe-2">
                        <div
                            class="menu menu-column menu-rounded menu-sub-indention menu-active-bg fw-semibold mb-auto">
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrapper d-flex flex-column flex-row-fluid">
                <div class="header header-bg">
                    <div class="container-fluid">
                        <div class="header-brand me-5">
                            <img alt="Logo" src="${___HTML_LOADER_IMPORT_1___}"
                                class="h-25px h-lg-30px d-none d-md-block" />
                        </div>
                        <div class="topbar d-flex align-items-stretch flex-shrink-0">
                            <div id="localizationContainer" class="mt-3 me-10"></div>
                            <div class="d-flex align-items-center">
                                <div class="user">
                                    <span class="text-hover-primary fs-6 fw-bold lh-1"></span>
                                    <i class="fas fa-chevron-down" aria-hidden="true"></i>
                                    <ul class="menu">
                                        <li><i class="fas fa-download" aria-hidden="true"></i><span
                                                class="download-result"></span></li>
                                        <li><i class="fas fa-sign-out-alt" aria-hidden="true"></i><span
                                                class="close-session"></span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content d-flex flex-column flex-column-fluid ">
                    <div id="feedBackContainer"></div>
                    <div class="post d-flex flex-column-fluid">
                        <div class="container-xxl">
                            <div class="card project-body">
                                <div class="row">
                                    <div class="col d-flex flex-wrap flex-stack">
                                        <div class="selected-project"><span class="text"></span><span class="selected"></span></div>
                                        <div class="back"><i class="fas fa-chevron-left"></i><span class="text"></span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-wrap flex-stack my-5 title">
                                <h2 class="fs-2 fw-semibold my-2"></h2>
                            </div>
                            <div class="row g-6 g-xl-9">
                                <div class="col-lg-12 col-xxl-12">
                                    <div class="card h-100">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col">
                                                    <div id="steps">
                                                        <ul id="progressbar"></ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="content"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="messages">
                        <i class="fa-solid fa-triangle-exclamation"></i>&nbsp;<span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>

</html>`;
// Exports
export default code;